import React, {Component} from 'react';
import Icon from './Icon';
import {View, StyleSheet} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import theme from '../../theme-config';

export default class OptionRow extends Component {
  styles = getStyles();

  render() {
    const {legend, title, value} = this.props;
    const {styles} = this;
    const optionStyle = value === 0 && styles.disabled;

    return (
      <View style={styles.optionContainer}>
        <Icon name="plus" style={[styles.icon, optionStyle]} />
        <View>
          <Text style={[styles.title, optionStyle]}>{title}</Text>
          {legend && <Text style={styles.legend}>{legend}</Text>}
        </View>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    optionContainer: {
      flexDirection: 'row',
      marginBottom: 10,
      alignItems: 'center',
    },
    icon: {
      fontSize: 18,
      marginRight: 10,
      color: theme.secondaryColor,
    },
    title: {
      marginRight: 20,
    },
    legend: {
      color: theme.gray.light,
    },
    disabled: {
      color: theme.gray.light,
    },
  });
